import BrakePad from "../../assets/productIcon/1.png";
import BrakeShoe from "../../assets/productIcon/2.png";
import BrakeFluid from "../../assets/productIcon/3.png";
import HID from "../../assets/productIcon/4.png";
import LED from "../../assets/productIcon/5.png";
import HALOGEN from "../../assets/productIcon/6.png";

export const allPotterySubCategorie = [
  {
    id: 1,
    categorieName: "Bike Category",
    subCategorie: [
      {
        path: 1,
        name: "Helmet",
        productIcon:
          "https://img.drz.lazcdn.com/static/bd/p/fd0437c78620a365afaf5537268826f6.jpg_720x720q80.jpg",
      },
      {
        path: 2,
        name: "Bike Brakes",
        productIcon:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTc4-3HiLAkNfIMpEMzgSTMpU33BKdQbcKKug&s",
      },
      {
        path: 3,
        name: "Bike Battery",
        productIcon: "https://m.media-amazon.com/images/I/61TcymrF39S.jpg",
      },
      {
        path: 4,
        name: "Bike light",
        productIcon:
          "https://brightstartw.com/wp-content/uploads/DB-6-Small-LED-Motorcycle-Driving-Lights.jpg",
      },
      {
        path: 5,
        name: "Exhust pipe",
        productIcon:
          "https://d29c80i09kxy2a.cloudfront.net/custom/blog-post-photo/mobile/gallery/motorcycle-exhaust-pipe-60fe5f7e837af.jpg",
      },
    ],
  },
  {
    id: 2,
    categorieName: "Pick Up",
    subCategorie: [
      {
        path: 1,
        name: " Engine",
        productIcon:
          "https://media.istockphoto.com/id/622426606/photo/diesel-engine-isolated-on-white.jpg?s=612x612&w=0&k=20&c=mp8XgoIYPd0kkUqV7aEOHkZFoptIKm7MiGozyBKZlUE=",
      },
      {
        path: 2,
        name: "Gearbox",
        productIcon:
          "https://i.ytimg.com/vi/ExWiuKz_RYc/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLCWXaBIpyxLGTM6iaAZKPhfSQie8A",
      },
      {
        path: 3,
        name: "Shock abrobaer",
        productIcon:
          "https://image.made-in-china.com/2f0j00PkuWHrlhOeqT/Car-Shock-Absorber-56100eb32c-for-Nissan-Pick-up-Cab-King-Cab-Navara-Np300.jpg",
      },
      {
        path: 4,
        name: "Spark plug",
        productIcon:
          "https://m.media-amazon.com/images/I/71xP0pSfNkL._AC_UF1000,1000_QL80_.jpg",
      },
      {
        path: 5,
        name: "Engine fan",
        productIcon:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSd8eOT1_9_C6iMby5IRtDQpb6XgpUpowpLww&s",
      },
    ],
  },
  {
    id: 3,
    categorieName: "Cng",
    subCategorie: [
      {
        path: 1,
        name: " Cng gas cylinder",
        productIcon: "https://metro-shine.com/images/product/CNG1.jpg",
      },
      {
        path: 2,
        name: "Cng",
        productIcon:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8hOl6R4qrD3cUTXrsr-sIJo0yyn5pTMq4iA&s",
      },
      {
        path: 3,
        name: "Tyre",
        productIcon:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQgiKguV85clFBL25pGgYuzu7jwPwqDdycIw&s",
      },
      {
        path: 4,
        name: "Glass",
        productIcon:
          "https://image.made-in-china.com/202f0j00cQjbzJZlEipo/CNG-4mm-10mm-Colored-Tinted-Glass-Clear-Float-Glass-Bronze-Brown-Blue-Grey-Gray-Green-Black-Float-Glass-Reflective-Glass-Building-Glass-Glass.webp",
      },
      {
        path: 5,
        name: "Front Mudgurd",
        productIcon:
          "https://5.imimg.com/data5/SELLER/Default/2023/9/340191368/IM/XC/AM/109382937/bajaj-auto-rikshaw-front-mudguard-500x500.jpeg",
      },
    ],
  },
  {
    id: 4,
    categorieName: "Car Categories  Brakes",
    subCategorie: [
      { path: 1, name: "Brake Pad", productIcon: BrakePad },
      { path: 2, name: "Brake Shoe", productIcon: BrakeShoe },
      { path: 3, name: "Brake Fluid", productIcon: BrakeFluid },
    ],
  },
  {
    id: 5,
    categorieName: "Buld",
    subCategorie: [
      { path: 1, name: "HID", productIcon: HID },
      { path: 2, name: "LED", productIcon: LED },
      { path: 3, name: "HALOGEN", productIcon: HALOGEN },
    ],
  },

  {
    id: 6,
    categorieName: "Tyre",
    subCategorie: [
      {
        path: 1,
        name: "Car Tyre",
        productIcon:
          "https://www.shutterstock.com/image-photo/car-tire-alurim-on-free-600nw-2355234971.jpg",
      },
      {
        path: 2,
        name: "Suv Tyre",
        productIcon:
          "https://media.autoexpress.co.uk/image/private/s--X-WVjvBW--/f_auto,t_content-image-full-desktop@1/v1658748090/autoexpress/2022/07/SUV%20tyre%20test%20-%20header.jpg",
      },
    ],
  },
  {
    id: 7,
    categorieName: "Electrical Parts",
    subCategorie: [
      {
        path: 1,
        name: "Ignition Coil",
        productIcon:
          "https://d2hucwwplm5rxi.cloudfront.net/wp-content/uploads/2023/06/13101358/Auto-Anatomy-Ignition-Coil-_-Body-2-12-6-23-1024x640.jpg",
      },
      {
        path: 2,
        name: "Ac Fual Pump",
        productIcon:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQe0T6D2n1guaELYX8MkZ35S2CO79TPBhMycg&s",
      },
      {
        path: 3,
        name: "Head Light Set",
        productIcon:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcResUcyysKDlM4oMTAbIsU8lzZTG_XWNhszDg&s",
      },
    ],
  },
  {
    id: 8,
    categorieName: "Filter",
    subCategorie: [
      {
        path: 1,
        name: "AIR FILTER",
        productIcon:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTc5brfZth-18V-a_4zCM5yg4EkFqu_7pYwWA&s",
      },
      {
        path: 2,
        name: "OIL FILTER",
        productIcon:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSi2-MO7263ZDH4zKqVbUsMQvspEtwVsdtYxw&s",
      },
      {
        path: 3,
        name: "A/C FILTER",
        productIcon:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRvoVCpH4nvhhrJfxSTHVDG-kXNzRF00edcMw&s",
      },
    ],
  },
  {
    id: 9,
    categorieName: "Car Care Items",
    subCategorie: [
      {
        path: 1,
        name: "Car Wash",
        productIcon:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR6IBDKsNvdzi6jsJ_JbW3q4puCEdKczQJENw&s",
      },
      {
        path: 2,
        name: "Car Polish",
        productIcon:
          "https://d2hucwwplm5rxi.cloudfront.net/wp-content/uploads/2021/07/08170528/car-wax-vs-polish-080720211005.jpg",
      },
      {
        path: 3,
        name: "Car Caleaner",
        productIcon:
          "https://cdn.shopify.com/s/files/1/0742/8938/1681/t/13/assets/CGM07529.JPG?v=1706812819",
      },
      {
        path: 4,
        name: "AIR Freshner",
        productIcon:
          "https://images-cdn.ubuy.co.in/6475db4ed79ae90f237f9cf2-ceeniu-smart-car-air-fresheners.jpg",
      },
    ],
  },
  {
    id: 10,
    categorieName: "Wiper Blade",
    subCategorie: [
      {
        path: 1,
        name: "Horn",
        productIcon:
          "https://sc04.alicdn.com/kf/HTB1w4YfXITxK1Rjy0Fg761ovpXam.png",
      },
      {
        path: 2,
        name: "Battery",
        productIcon:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR7EYpgP7lkt9TnCBVgt6_5RLAi_7ylC-upxA&s",
      },
      {
        path: 3,
        name: "Spark Plug",
        productIcon:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQPp1ocfFyYoa72CfPyvRa_lcxAg4HCcUcuww&s",
      },
      {
        path: 4,
        name: "Shock Absorber",
        productIcon:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrs9zWHjxSsmOiR6rTrlqOcFhSyODwPawbSw&s",
      },
    ],
  },
  {
    id: 11,
    categorieName: "Lubricant",
    subCategorie: [
      {
        path: 1,
        name: "Engine Oil",
        productIcon:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/68/SIGAUS_aceite.jpg/1200px-SIGAUS_aceite.jpg",
      },
      {
        path: 2,
        name: "ATF",
        productIcon:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSu1sUiF4FjxpwVShp9GA8rP7ju-dfZSS2WFQ&s",
      },
      {
        path: 3,
        name: "CVTF",
        productIcon:
          "data:image/jpeg;base64,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",
      },
      {
        path: 4,
        name: "COOLANT",
        productIcon:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRwREh-Xi0eLVfyxMoxM1f5EUbuWR6Etd_Lhw&s",
      },
    ],
  },
  {
    id: 12,
    categorieName: "BODY PARTS",
    subCategorie: [
      {
        path: 1,
        name: "Engine",
        productIcon:
          "https://tyrepoint.pk/wp-content/uploads/2018/09/Car-Engine.jpg",
      },
    ],
  },
];

export const ProductDashboard = [
  { name: "Payment Schedule", path: "/dashboard/paymentSchedule" },
  { name: "Delivery Schedule", path: "/dashboard/delivery_schedule" },
  { name: "Forgot Password", path: "/forget_password" },
  { name: "Reset Password", path: "/reset_password" },
];
